import React, { Fragment } from 'react';
import { array, bool, func } from 'prop-types';

import AttachmentItem from './item';
import SvgIcon from '../../svg-icon';
import { theme } from '../../../styles';
import UploadAttachments from '../header/upload-attachments';
import { UploadWrapper, UploadText } from './styled-components';


const AttachmentsList = ({
  minView,
  isLoading,
  attachments,
  openFilePicker,
  onAttachmentsAdd,
  onAttachmentRemove,
}) => (
  <Fragment>
    {(attachments.length === 0 && !minView) && <div>Attachments will be here</div>}

    {(minView && attachments.length === 0) &&
    <UploadWrapper>
      <SvgIcon hoverColor={theme.colors.gullGray} type="upload" />
      <div>
        <UploadText>Drag and Drop or <span>
          <UploadAttachments
            {...{
              openFilePicker, onAttachmentsAdd, isLoading, minView,
            }}
          />
        </span>
        </UploadText>
      </div>
    </UploadWrapper>}

    {attachments.map(attachment => (
      <AttachmentItem
        key={`attachment-${attachment._id}`}
        attachment={attachment}
        onAttachmentRemove={onAttachmentRemove}
        minView={minView}
      />
    ))}
  </Fragment>
);

AttachmentsList.propTypes = {
  isLoading: bool,
  openFilePicker: func,
  onAttachmentsAdd: func,
  onAttachmentRemove: func,
  minView: bool.isRequired,
  attachments: array.isRequired,
};

AttachmentsList.defaultProps = {
  isLoading: false,
  openFilePicker: null,
  onAttachmentsAdd: null,
  onAttachmentRemove: null,
};

export default AttachmentsList;



// WEBPACK FOOTER //
// ./src/components/attachments/list/index.js